// import React from "react";
// import { useAppSelector } from "../../../../Redux Toolkit/Store";

// const grid = [
//   {"categoryId":"women_lehenga_cholis",
//         "section": "GRID",
//         "name": "women lehenga cholis",
//     image:
//       "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/23807268/2023/6/29/9930b235-5318-4755-abbe-08f99e969e781688026636544LehengaCholi7.jpg",
//   },
//   {"categoryId":"men_formal_shoes",
//         "section": "GRID",
//         "name": "men formal shoes",
//     image:
//       "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/24651572/2023/8/25/4fbf6d8c-d093-46c5-a5a6-7dd67c0c76551692964752597HouseofPataudiMenTanFauxLeatherFormalSlipOnLoafers1.jpg",
//   },
//   {"categoryId":"women_lehenga_cholis",
//         "section": "GRID",
//         "name": "women lehenga cholis",
//     image:
//       "https://images.pexels.com/photos/12730873/pexels-photo-12730873.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
//   },
//   {"categoryId":"men_sherwanis",
//         "section": "GRID",
//         "name": "men sherwanis",
//     image:
//       "https://shreeman.in/cdn/shop/files/20_3cfbd5a3-ecb6-482a-b798-7ffd9de1c784.jpg?v=1712061674&width=700",
//   },
//   {"categoryId":"women_jewellery",
//         "section": "GRID",
//         "name": "women jewellery",
//     image:
//       "https://media.istockphoto.com/id/1276740597/photo/indian-traditional-gold-necklace.jpg?b=1&s=612x612&w=0&k=20&c=S-QnNZKqf2u3L-GIaDiIinNRU74GBWQaIDwY7gYJboY=",
//   },
//   {"categoryId":"women_footwear",
//         "section": "GRID",
//         "name": "women footwear",
//     image:
//       "https://assets.myntassets.com/h_720,q_90,w_540/v1/assets/images/13837166/2021/8/19/04e40e02-4c56-4705-94d0-f444b29973aa1629373611707-House-of-Pataudi-Women-Maroon-Embellished-Handcrafted-Wedges-1.jpg",
//   },
// ];
// const TopBrand = () => {
//   const {homePage}=useAppSelector(store=>store)
//   return (
//     <div className="grid grid-rows-12 grid-cols-12 lg:h-[600px] gap-[clamp(6px,0.9vw,20px)] px-3 sm:px-4 md:px-5 lg:px-20">
//       <div className="col-span-3 row-span-12 text-white rounded">
//         <img
//           className="w-full h-full object-cover rounded-md"
//           src={homePage.homePageData?.grid[0].image}
//           alt=""
//         />
//       </div>

//       <div className="col-span-2 row-span-6 text-white rounded">
//         <img
//           className="w-full h-full object-cover rounded-md"
//           src={homePage.homePageData?.grid[1].image}
//           alt=""
//         />
//       </div>

//       <div className="col-span-4 row-span-6 text-white rounded">
//         <img
//           className="w-full h-full object-cover object-top rounded-md"
//           src={homePage.homePageData?.grid[2].image}
//           alt=""
//         />
//       </div>

//       <div className="col-span-3 row-span-12 text-white rounded">
//         <img
//           className="w-full h-full object-cover object-top rounded-md"
//           src={homePage.homePageData?.grid[3].image}
//           alt=""
//         />
//       </div>

//       <div className="col-span-4 row-span-6 text-white rounded">
//         <img
//           className="w-full h-full object-cover object-top rounded-md"
//           src={homePage.homePageData?.grid[4].image}
//           alt=""
//         />
//       </div>
//       <div className="col-span-2 row-span-6 text-white rounded">
//         <img
//           className="w-full h-full object-cover rounded-md"
//           src={homePage.homePageData?.grid[5].image}
//           alt=""
//         />
//       </div>

//       {/* https://tristenwallace.com/wp-content/uploads/2022/06/wed-7.jpg */}
//     </div>
//   );
// };

// export default TopBrand;


// Making changes for modern website

// import React from "react";
// import { ChevronLeft, ChevronRight } from "@mui/icons-material";
// import { IconButton } from "@mui/material";
// import { useAppSelector } from "../../../../Redux Toolkit/Store";

// const TopBrand = () => {
//   const { homePage } = useAppSelector((store) => store);
//   const slides = homePage.homePageData?.grid || [];
//   const [activeIndex, setActiveIndex] = React.useState(0);

//   const goToSlide = React.useCallback(
//     (index: number) => {
//       if (!slides.length) return;
//       const normalizedIndex = (index + slides.length) % slides.length;
//       setActiveIndex(normalizedIndex);
//     },
//     [slides.length]
//   );

//   const goToPrevious = () => goToSlide(activeIndex - 1);
//   const goToNext = () => goToSlide(activeIndex + 1);

//   React.useEffect(() => {
//     if (slides.length <= 1) return;

//     const interval = setInterval(() => {
//       setActiveIndex((prev) => (prev + 1) % slides.length);
//     }, 4000);

//     return () => clearInterval(interval);
//   }, [slides.length]);

//   if (!slides.length) return null;

//   return (
//     <section className="w-full">
//       <div className="relative overflow-hidden rounded-[28px] bg-white shadow-[0_18px_60px_rgba(15,23,42,0.12)]">
//         {/* <div className="relative h-[260px] sm:h-[340px] md:h-[420px] lg:h-[540px]"> */}
//         <div className="relative h-[320px] sm:h-[420px] md:h-[520px] lg:h-[620px] xl:h-[720px]">
//           {slides.map((item, index) => {
//             const isActive = index === activeIndex;

//             return (
//               <div
//                 key={item.id || item.categoryId || index}
//                 className={`absolute inset-0 transition-all duration-700 ${isActive
//                     ? "opacity-100 scale-100 z-10"
//                     : "opacity-0 scale-[1.03] z-0 pointer-events-none"
//                   }`}
//               >
//                 <img
//                   src={item.image}
//                   alt={item.name || `slide-${index + 1}`}
//                   className="h-full w-full object-cover"
//                 />

//                 {/* subtle overlay only */}
//                 <div className="absolute inset-0 bg-black/20" />

//                 {/* title only */}
//                 {item.name && (
//                   <div className="absolute bottom-6 left-6 sm:left-10 text-white">
//                     <h2 className="text-xl sm:text-3xl lg:text-5xl font-semibold">
//                       {item.name}
//                     </h2>
//                   </div>
//                 )}
//               </div>
//             );
//           })}

//           {/* arrows */}
//           {slides.length > 1 && (
//             <>
//               <IconButton
//                 onClick={goToPrevious}
//                 sx={{
//                   position: "absolute",
//                   left: { xs: 10, md: 20 },
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   zIndex: 20,
//                   backgroundColor: "rgba(255,255,255,0.85)",
//                   "&:hover": { backgroundColor: "white" },
//                 }}
//               >
//                 <ChevronLeft />
//               </IconButton>

//               <IconButton
//                 onClick={goToNext}
//                 sx={{
//                   position: "absolute",
//                   right: { xs: 10, md: 20 },
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   zIndex: 20,
//                   backgroundColor: "rgba(255,255,255,0.85)",
//                   "&:hover": { backgroundColor: "white" },
//                 }}
//               >
//                 <ChevronRight />
//               </IconButton>
//             </>
//           )}
//         </div>

//         {/* dots only */}
//         {slides.length > 1 && (
//           <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
//             {slides.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => goToSlide(index)}
//                 className={`h-2.5 rounded-full transition-all ${index === activeIndex
//                     ? "w-6 bg-white"
//                     : "w-2.5 bg-white/60"
//                   }`}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default TopBrand;


import React from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useAppSelector } from "../../../../Redux Toolkit/Store";

const TopBrand = () => {
  const { homePage } = useAppSelector((store) => store);
  const slides = homePage.homePageData?.grid || [];
  const [activeIndex, setActiveIndex] = React.useState(0);

  const goToSlide = React.useCallback(
    (index: number) => {
      if (!slides.length) return;
      const normalizedIndex = (index + slides.length) % slides.length;
      setActiveIndex(normalizedIndex);
    },
    [slides.length]
  );

  const goToPrevious = () => goToSlide(activeIndex - 1);
  const goToNext = () => goToSlide(activeIndex + 1);

  React.useEffect(() => {
    if (slides.length <= 1) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides.length]);

  if (!slides.length) return null;

  return (
    <section className="relative z-0 w-full pt-1 sm:pt-2">
      <div className="relative z-0 w-full overflow-hidden rounded-[18px] sm:rounded-[22px] bg-white">
        <div className="relative h-[260px] sm:h-[340px] md:h-[420px] lg:h-[500px] xl:h-[560px]">
          {slides.map((item, index) => {
            const isActive = index === activeIndex;

            return (
              <div
                key={item.id || item.categoryId || index}
                className={`absolute inset-0 transition-all duration-700 ${
                  isActive
                    ? "opacity-100 scale-100 z-[1]"
                    : "opacity-0 scale-[1.02] z-0 pointer-events-none"
                }`}
              >
                <img
                  src={item.image}
                  alt={item.name || `slide-${index + 1}`}
                  className="h-full w-full object-cover"
                />

                <div className="absolute inset-0 bg-black/15" />

                {item.name && (
                  <div className="absolute bottom-5 left-5 sm:bottom-7 sm:left-8 lg:bottom-8 lg:left-10 z-[2] text-white">
                    <h2 className="text-lg sm:text-2xl md:text-3xl lg:text-4xl font-semibold drop-shadow-[0_2px_10px_rgba(0,0,0,0.35)]">
                      {item.name}
                    </h2>
                  </div>
                )}
              </div>
            );
          })}

          {slides.length > 1 && (
            <>
              <IconButton
                onClick={goToPrevious}
                sx={{
                  position: "absolute",
                  left: { xs: 10, sm: 16, md: 20 },
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 2,
                  backgroundColor: "rgba(255,255,255,0.88)",
                  width: { xs: 38, sm: 42, md: 46 },
                  height: { xs: 38, sm: 42, md: 46 },
                  "&:hover": { backgroundColor: "white" },
                  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                }}
              >
                <ChevronLeft />
              </IconButton>

              <IconButton
                onClick={goToNext}
                sx={{
                  position: "absolute",
                  right: { xs: 10, sm: 16, md: 20 },
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 2,
                  backgroundColor: "rgba(255,255,255,0.88)",
                  width: { xs: 38, sm: 42, md: 46 },
                  height: { xs: 38, sm: 42, md: 46 },
                  "&:hover": { backgroundColor: "white" },
                  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                }}
              >
                <ChevronRight />
              </IconButton>
            </>
          )}

          {slides.length > 1 && (
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-[2] flex gap-2">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`h-2 rounded-full transition-all duration-300 ${
                    index === activeIndex ? "w-6 bg-white" : "w-2 bg-white/65"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default TopBrand;